import client, { requestConfig } from "./client";

const endpoint = "/api/obt-config";

const get = () => client.get(endpoint, {}, requestConfig());

export default {
  get,
};
